import SearchBar from 'components/Autosuggest/Autosuggest';
import React, { useEffect, useState } from 'react';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import { addOrderItem, searchItems } from 'services';

const AddOrderItemModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const { orderId, onSuccess, toggleModal } = props;
  const [item, setItem] = useState<Record<string, any>>({});
  const [itemId, setItemId] = useState<string>('');
  const [quantity, setQuantity] = useState<number>(0);
  
  const handleAddOrderItem = async () => {
    setLoading(true);
    try {
      await addOrderItem(orderId, itemId, quantity);
      await onSuccess();
      showSuccess('Order Item added successfully');
      setQuantity(0);
      setItemId('');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleSuggestionClick = (suggestion: Record<string, any>) => {
    const item: Record<string, any> = {};
    item.id = suggestion.id;
    item.name = suggestion.displayName;
    setItem(item);
    setItemId(item.id);
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Order</div>
            <div className={styles['modal-title']}>Add Order Item</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['autosuggest-input']}>
            {/* TODO: this will search from all the items but we want only those items which are allowed for Home Box */}
            <SearchBar
              value={item.name || ''}
              setValue={value => setItem({ ...item, name: value })}
              searchAPI={searchItems}
              searchAPIParamKey={'term'}
              onSuggestionClicked={handleSuggestionClick}
            />
          </div>
          <div className={'mt-3'}>
            <div className={styles['label']}>Quantity</div>
            <input
              type={'number'}
              value={quantity}
              className={'form-control'}
              onChange={e => setQuantity(parseInt(e.target.value))}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleAddOrderItem}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOrderItemModal;
